import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { dateToDayOfMonthNumber, dateToDayOfWeekShortName, isToday } from "utils/dateUtils";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 5,
    },
    dayName: {
        fontSize: "small",
        color: "#565656",
    },
}));

export function Header(props) {
    const { date } = props;
    const classes = useStyles();

    const getDayName = () => dateToDayOfWeekShortName(date);
    const getDayNumber = () => dateToDayOfMonthNumber(date);
    const getColor = () => (isToday(date) ? "primary" : "default");

    return (
        <div className={classes.container}>
            <span className={classes.dayName}>{getDayName()}</span>
            <IconButton size="small" color={getColor()} component="span">
                {getDayNumber()}
            </IconButton>
        </div>
    );
}
const Week = { Header };
export default Week;
